import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const TROUBLESHOOTING_GUIDES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('TROUBLESHOOTING_GUIDES');
export const TROUBLESHOOTING_GUIDES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	TROUBLESHOOTING_GUIDES_CRUD_ACTION_CONSTANTS
);
